module.exports = __webpack_public_path__ + "static/media/400119_01.c51584ba.png";